import React from 'react';
import {Link} from 'react-router-dom';
import {
    Card, CardBlock, CardGroup, Button,
    ListGroup, ListGroupItem
} from 'reactstrap';


import {api, request, API_URL,url_firma} from '../../actions/_request';

import Sign from '../../components/sign';

import swal from 'sweetalert2';
import FaPaperplaneO from 'react-icons/lib/fa/paper-plane-o';

class Term extends React.Component {

	constructor(props) {

		super(props)

		this.state = {
			ticket: { cliente: {}},
			cliente: null,
			rows:[],

		};
		this.sendEmail 		= this.sendEmail.bind(this);
	}
		formateo(value) {
     var decimals =  2;
   var  separators =[',', ",", '.'];
    var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return '' +number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return '' + result;
}

	componentDidMount() {

		let self = this;
		const {params} = this.props.match;

		if(params.id) {

			api().get('/ticketsv2/'+params.id).then((response) => {

				if(response.status === 200) {

					let data = response.data;

					self.cliente = data.cliente;

					let ticket= data.ticket;

					api().get('/listaticket/'+params.id)
			        .then(function(response)
			        {
			            self.setState({
			            	ticket: ticket,
			                rows : response.data
			            });
			        });

				}

			});
		}

	}

	mensaje() {
		// let {ticket} = this.state;

		// this.props.history.push('/tickets/ver/'+ticket.id);
		// var el = document.getElementById('targetFrame');
		swal('Error', "Firma Vacia",'error');


    // document.getElementById('iframe1').contentWindow.alerta('Esta alerta del iframe se llamó desde afuera del iframe');
		
	}

	sendEmail() {
		let {ticket} = this.state;
		let self=this;
		 var iframe = document.getElementById( "iframe1" );
		 var ifrDocument = iframe.contentDocument || iframe.contentWindow.document;
		 var firma = ifrDocument .getElementById( "txt_imagen" );
		 // console.log('txt_imagen',firma.value)

		                api().post('/enviarComprobante', { 
		                	firma: firma.value,
							ticketid: ticket.id,
							opcion:'final'})
						.then(function(response)
			            {    
			                if(response.status === 200)
			                {   
			                   	 // window.open(API_URL+"/ticketsv2/printTicketFinal/"+ticket.id);
		                         self.props.history.push('/tickets/ver/'+ticket.id);
			                }
			            })
						.catch( error => {
							swal.showValidationError(`Solicitar Ayuda a un Administrador`);
						});
	}



	render() {

		const {ticket} = this.state;

		return (
		    <div className="">
		        <div className="view-content mt-3">
		            <div className="row mb-4 justify-content-center align-items-center">
						<div className="col-9 col-md-9">

		            <Card className="mb-3 invoice-card">
		                <CardBlock>
		                    <div className="d-flex justify-content-between flex-wrap">
		                        <span style={{color: '#ED0303', fontSize: '27px'}}>Maxicomm</span>
		                        <div>
		                            <h4 className="text-uppercase">Ticket</h4>
		                            <h6>clave: {ticket.clave || '-'}</h6>
		                            <small>Fecha: {ticket.fecha_ticket || '-'}</small>
		                        </div>
		                    </div>
		                    <hr/>
		                    <CardGroup>
		                        <Card>
		                            <CardBlock>
		                                <u>Firma de Comformidad:</u>
		                                <div className="col-12 col-md-12">							
							<table className="table tabla_items">
						        <thead>
						            <tr>
						                <th>Descripcion</th>						                
						                <th>Precio U.</th>
						                <th>Cantidad</th>
						                <th>IVA </th>
						                <th>Total</th>						              
						            </tr>
						        </thead>
						        <tbody className="">
						            {this.state.rows.map((item, i) => 
					            		<tr key={i}>
					                		<td width="65%">
					                			 {item.descripcion} 
					                		</td>
					                		<td width="12%">
					                			 {this.formateo(item.precio)} 	  
					                		</td>
					                		<td width="5%">
					                			{item.cantidad} 
					                		</td>
					                		<td width="8%">
					                			{item.iva+' %'}
					                		</td>
					                		<td width="10%">
					                			{this.formateo(item.total)} 
					                		</td>
					            		</tr>
						            )}
						        </tbody>
						    </table>
						    <hr/>
						    	<div className="row ">
						    		<div className="col-md-8 float-right">
						    		</div>
						    		<div className="col-md-4 float-right">
								    	<table className="table">{/*sumatoria de productos */}
								    		<thead>
								    			<tr>
								                	<th>sub-total:</th>
								                	<td>							  
								    						{'$'+this.formateo(this.state.ticket.subtotal)}								    					
								    				</td>
								    			</tr>
								    			<tr>
								                	<th>iva:</th>
								                	<td>
								    					{'$'+this.formateo(this.state.ticket.iva)}
								    					
								    				</td>
								                </tr>
								                <tr>
								                	<th>Total:</th>
								                	<td>
								    					{'$'+this.formateo(this.state.ticket.total)}								    					
								    				</td>
								                </tr>
								    		</thead>
								    	</table>
								    </div>
								   
						    	</div>

						    	
						    	
						    </div>
		                            </CardBlock>
		                        </Card>
		                    </CardGroup>
		                  
		                    <hr/>

		                     
		                	<br/><br/>

		                	<Link id="Boton_regresar_ticket_firma" to={`/tickets/ver/`+ticket.id}>
	                            <Button color="secondary" className="btn-sm  d-none" >
	                                Regresar
	                            </Button>
	                         </Link>

	                         
	                            <Button color="secondary" className="btn-sm  d-none" id="Boton_guardar_ticket_firma" onClick={this.sendEmail}>
	                                Guardar
	                            </Button>
	                             <Button color="secondary" className="btn-sm  d-none" id="Boton_Menaje_ticket_firma" onClick={this.mensaje}>
	                                Mensaje
	                            </Button>
	                         
		                </CardBlock>
		            </Card>

		             </div>
		                    </div>

		        </div>
		    </div>
		)
	}

}


export default Term





// WEBPACK FOOTER //
// ./src/views/ticket/term_.js